import { OptimizelyError } from "../../error/optimizly_error";
import { RETRY_CANCELLED } from "error_message";
import { resolvablePromise } from "../promise/resolvablePromise";
const runTask = (task, returnPromise, cancelSignal, backoff, retryRemaining) => {
    task().then((res) => {
        returnPromise.resolve(res);
    }).catch((e) => {
        var _a;
        if (retryRemaining === 0) {
            returnPromise.reject(e);
            return;
        }
        if (cancelSignal.cancelled) {
            returnPromise.reject(new OptimizelyError(RETRY_CANCELLED));
            return;
        }
        const delay = (_a = backoff === null || backoff === void 0 ? void 0 : backoff.backoff()) !== null && _a !== void 0 ? _a : 0;
        setTimeout(() => {
            retryRemaining = retryRemaining === undefined ? undefined : retryRemaining - 1;
            runTask(task, returnPromise, cancelSignal, backoff, retryRemaining);
        }, delay);
    });
};
export const runWithRetry = (task, backoff, maxRetries) => {
    const returnPromise = resolvablePromise();
    const cancelSignal = { cancelled: false };
    const cancelRetry = () => {
        cancelSignal.cancelled = true;
    };
    runTask(task, returnPromise, cancelSignal, backoff, maxRetries);
    return { cancelRetry, result: returnPromise.promise };
};
export const __platforms = ['__universal__'];
//# sourceMappingURL=backoff_retry_runner.js.map